import './more.css';
import './Output.css';
import TopNav from './components/TopNav';
import MiddleNav from './components/MiddleNav';
import Intro from './components/Intro';
import About from './components/About';
import Experience from './components/Experience';
import Builds from './components/Builds';
import Contact from './components/Contact';
import Footer from './components/Footer';


function App() {
  const d = new Date().getFullYear();

  return (
    <div className="w-full h-full font-orbitron">
    <TopNav />
    <Intro />
    <MiddleNav />
    <About />
    <Experience />
    <Builds />
    <Contact />
      <Footer year={d} />

    </div>
  );
}

export default App;
